import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { DevelopmentHelpers } from 'app/shared/utilities/developHelpers';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'activity-type-select',
  templateUrl: './activity-type-select.component.html',
  styleUrls: ['./activity-type-select.component.css']
})
export class ActivityTypeSelectComponent implements OnInit, OnDestroy, OnChanges {

  @Input() typeId : string;
  @Output() typeIdChange = new EventEmitter();
  @Output() changed = new EventEmitter();
  selectedType:ActivityType;
  allTypes: ActivityType[]; // 
  types: ActivityType[]; // filtered types
  dropOpen = false;

  help = new DevelopmentHelpers();
  inputId;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.inputId = 'activityTypeInput' + this.help.guid.newGUID();
    document.addEventListener('click',()=> this.autoClose() );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.typeId && changes.typeId.currentValue == undefined) this.getActivityTypes();
    if(!!changes.typeId && !!changes.typeId.currentValue && changes.typeId.currentValue != changes.typeId.previousValue) {
      if(!this.allTypes) this.getActivityTypes();
      else {
        this.selectedType = this.allTypes.find(x => x.id == this.typeId);
      }
    }
    if(!!changes.typeId && changes.typeId.currentValue == null) {
      if(!this.allTypes) this.getActivityTypes();
      else {
        this.selectedType = this.types[0];
        this.changed.emit(this.selectedType);
        this.typeIdChange.emit(this.selectedType.id)
      }
    }
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click',()=> this.autoClose() );
  }

  getActivityTypes(){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Activity/ActivityTypes',
      { headers }).subscribe(
        (types: ActivityType[])=>{
          this.allTypes = types.sort((a,b)=> a.sort < b.sort ? -1 : 1);
          this.types = this.allTypes;
          if(!!this.types && !!this.typeId) {
            this.selectedType = this.types.find(x => x.id == this.typeId);
          }
          else if(!!this.types && this.types.length > 0 && !this.typeId) {
            this.selectedType = this.types[0]
            this.changed.emit(this.selectedType);
            this.typeIdChange.emit(this.selectedType.id)
          };
        }
      )
  };

  changeSort(type){
    switch(type){
      case 'sort' : {
        this.allTypes = this.allTypes.sort((a,b)=> a.sort < b.sort ? -1 : 1);
        break
      }
      case 'name' : {
        this.allTypes = this.allTypes.sort((a,b)=> a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        break
      }
    }
  }

  selectInputText(){
    let a = document.getElementById(this.inputId) as HTMLInputElement;
    a.select();
  }

  filter(e:KeyboardEvent){
    let i = e.target as HTMLInputElement;
    if(!this.dropOpen) this.dropOpen = true;
    if(!i.value || e.key == 'Backspace' || e.code == 'Backspace') {
      this.types = this.allTypes;
    }
    else {

      this.types = this.allTypes.filter(x => x.name.toLowerCase().match(i.value.toLowerCase())).sort((a,b)=> a.sort < b.sort ? -1 : 1);
      if(this.types.length == 1) {
        document.dispatchEvent(new KeyboardEvent('keypress', {'key': 'Tab'}))
        //  document.getElementById(this.inputId).blur();
        this.onSelect(this.types[0])
      };
    }
    console.log(e)
  }

  onSelect(a:ActivityType){
    // manaually reset the type name if user has deleted some characters (only happens if user deletes some characters and then selects the same type)
    if(!!this.selectedType && a.id == this.selectedType.id){
      this.setInputValue(a);
    }
    this.selectedType = a;
    this.typeIdChange.emit(a.id);
    this.changed.emit(a);
    this.dropOpen = false;
  }

  freshOpen(){
    this.types = this.allTypes;
    this.dropOpen = true;
  }

  autoClose(){
    if(this.dropOpen && !!this.allTypes) setTimeout(()=> {
      this.dropOpen = false;
      if(!!this.selectedType) this.setInputValue(this.selectedType);
      else this.setInputValue( this.allTypes.find(x => x.id == this.typeId) );
    },100)
  }

  delayOpen(){
    setTimeout(()=> this.freshOpen(),50)
  }

  arrowKeyPressed(e:KeyboardEvent){

    return false
  }

  setInputValue(a:ActivityType){
    let div = document.getElementById(this.inputId) as HTMLInputElement;
      div.value = a.name;
  }

  preventKey(e:KeyboardEvent){
    console.log(e)
    if(e.key == 'Tab') e.preventDefault()
  }
}

class ActivityType {
  id: string;
  name: string;
  icon: string = "fas fa-question";
  sort: number = 0;
}